import RequestManager from "src/requests/RequestManager";
import { Group, Team } from "../interfaces";
import { isMockDataActive, standings as mockResult } from "../mockData";
import { StandingsTask } from "../tasks";
import { parseTeam } from "../utils";

type TeamsByGroup = Group[]

// Se usa en NodoMundial/Grupos
export default async function getTeamsByGroup(): Promise<TeamsByGroup> {
    const task = new StandingsTask();
    let result;
    if (isMockDataActive) {
        result = mockResult;
    }
    result = await RequestManager.addRequest(task);
    const standings = result.standings || [];
    const teamsByGroup = standings.map((group: any) => ({
        groupName: group.phase && group.phase.names && group.phase.names.default,
        groupId: group.phase && group.phase.id,
        teams: (group.participants || []).map((team: any) => {
            return parseTeam(team);
        })
    }));
    
    return teamsByGroup;
}


// WEBPACK FOOTER //
// ./src/mundial/requests/api/getTeamsByGroup.ts